import { toast } from 'react-toastify';

export const showSuccessToast = (message) => {
  toast.success(message);
};

export const showErrorToast = (message) => {
  if (message) {
    toast.error(message);
  }
};

export const showInfoToast = (message) => {
  toast.info(message);
};
export const showWarningToast = (message) => {
  toast.warn(message);
};
